import Vue from "vue";


Vue.config.API_URL = "https://pchelp.1oo0.ru/backend/api/";
Vue.config.IMAGE_URL = "https://pchelp.1oo0.ru/";
Vue.config.BASE_URL = "https://pchelp.1oo0.ru";
Vue.config.TG_BOT = "pchelp1oo0rubot";